<template>
  <div ref="withdraw">
    <!-- top -->
    <van-sticky>
      <van-nav-bar title="查询会员信息" left-arrow @click-left="onClickLeft">
        <!-- <template #right>
          <div class="rightSelect" @click="open = true">
            <van-icon name="filter-o" class="icon" />
            筛选
          </div>
        </template> -->
      </van-nav-bar>
    </van-sticky>
    <!-- top -->
    <van-datetime-picker
      v-model="firstDate"
      type="date"
      title="选择年月日"
      v-if="showF"
      @cancel="cancelFTome(firstDate)"
      @confirm="setFTome"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-datetime-picker
      v-model="endDate"
      type="date"
      title="选择年月日"
      v-if="showS"
      @cancel="cancelSTome(endDate)"
      @confirm="setSTome"
      :min-date="minDate"
      :max-date="maxDate"
    />

    <div
      class="wrap"
      :style="{
        backgroundImage:
          'url(' +
          $returnColor().path +
          ($store.state.selfData.member_id
            ? '/home-page_bg.png'
            : '/home-page_bg.png') +
          ')',
      }"
    >
      <div class="contentWrap">
        <van-form>
          <van-field
            readonly
            clickable
            name="类型"
            :value="year.text"
            label="类型"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="dateOption"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
          <van-field
            v-model="searchValue"
            type="text"
            :name="year.text"
            :label="year.text"
            :placeholder="year.text"
          />
          <div style="margin: 16px">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              @click="search"
            >
              搜寻
            </van-button>
          </div>
        </van-form>

        <div class="tableWrap" v-if="depositList">
          <p class="tableContent">
            <span class="tableTitle"> ID </span>
            <span class="tablesContent">
              {{ depositList.id }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 帐号 </span>
            <span class="tablesContent">
              {{ depositList.username }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 姓名 </span>
            <span class="tablesContent">
              {{ depositList.name }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 层级 </span>
            <span class="tablesContent">
              {{ depositList.member_level_name }}
            </span>
          </p>
          <p class="tableContent" style="border-bottom: 1px solid #00000033">
            <span class="tableTitle"> 上级号 </span>
            <span class="tablesContent">
              {{ depositList.supervisor_id }}
            </span>
          </p>

          <p class="tableContent">
            <span class="tableTitle"> 状态 </span>
            <span class="tablesContent">
              {{ depositList.status == 1 ? "启用" : "未启用" }}
            </span>
          </p>
          <p class="tableContent" style="border-bottom: 1px solid #00000033">
            <span class="tableTitle"> 停权 </span>
            <span class="tablesContent">
              {{ depositList.locked == 1 ? "启用" : "未启用" }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 冻结资金 </span>
            <span class="tablesContent">
              {{ depositList.freeze_balance || 0 }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 红利 </span>
            <span class="tablesContent">
              {{ depositList.bonus }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 余额 </span>
            <span class="tablesContent">
              {{ depositList.balance }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  data() {
    return {
      minDate: new Date(2021, 0, 1),
      maxDate: new Date(),
      type: false,
      open: false,
      currentGropId: "",
      year: { text: "用户号", value: "id" },
      month:
        String(new Date().getMonth() + 1).length == 1
          ? "0" + String(new Date().getMonth() + 1)
          : String(new Date().getMonth() + 1),
      dateOption: [
        { text: "用户号", value: "id" },
        { text: "帐号", value: "username" },
        { text: "姓名", value: "name" },
      ],
      monthOption: [
        { text: "01", value: "01" },
        { text: "02", value: "02" },
        { text: "03", value: "03" },
        { text: "04", value: "04" },
        { text: "05", value: "05" },
        { text: "06", value: "06" },
        { text: "07", value: "07" },
        { text: "08", value: "08" },
        { text: "09", value: "09" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
      ],
      depositPaginate: {},
      depositList: false,
      depositPage: 1,
      withdrawList: [],
      withdrawPaginate: {},
      withdrawPage: 1,
      isLoading: false,
      value: "",
      showPicker: false,
      dates: { startDate: "" },
      firstDate: "",
      endDate: "",
      showF: false,
      showS: false,
      inFilter: false,
      saveData: false,
      showFast: true,
      next_page: true,
      current_page: 1,
      selectOrdder: [],
      searchOrderId: "",
      pay_bank_no: "",
      searchValue: "",
    };
  },
  methods: {
    search() {
      if (!this.searchValue) {
        this.$toast.fail("请输入搜寻");
        return;
      }
      this.$http
        .get(`/mobile/advanced/subs`, {
          params: {
            search_type: this.year.value,
            search: this.searchValue,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (JSON.stringify(res.data.data) == "[]") {
              this.$toast.fail("查无用户");
              return;
            }
            this.depositList = res.data.data;
          }
        });
    },
    sendShop() {
      let snedData = this.selectOrdder.map((e) => {
        return e.order_id;
      });
      this.$dialog.confirm({
        title: "传送商城",
        message: `确认传送商城 ${snedData.length}笔`,

        beforeClose(method, done) {
          if (method == "confirm") {
            this.$http
              .post(`/mobile/paymentSubmit`, { ids: snedData })
              .then((res) => {
                if (res.data.code == 0) {
                  this.$toast.success("成功");
                  this.selectOrdder = [];
                }
              });
          }
          done();
        },
      });
    },
    handleSelectionChange(val) {
      this.selectOrdder = val;
    },
    clearSelect() {
      this.type = false;
      this.firstDate = "";
      this.endDate = "";
      this.searchOrderId = "";
      this.pay_bank_no = "";
    },
    onCopy() {
      this.$toast.success("已复制");
    },
    setFTome(d) {
      this.firstDate = this.$returnTime(d);
      this.showF = false;
    },
    setSTome(d) {
      this.endDate = this.$returnTime(d);
      this.showS = false;
    },
    cancelSTome() {
      this.showS = false;
      return;
    },
    cancelFTome() {
      this.showF = false;
      return;
    },
    onConfirm(value) {
      this.year = value;
      this.showPicker = false;
    },
    onClickLeft() {
      this.$router.push(`/`);
    },
  },
  created() {
    // this.getDeposit();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollPage);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollPage);
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  // background-image: url("/home-page_bg.png");
  // background-position: center center;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contentWrap {
  max-width: 350px;
  width: 100%;
}
.dropdown {
  margin-bottom: 15px;
  position: relative;
  .arrow {
    position: absolute;
    right: 10px;
    top: 35%;
  }
  .van-dropdown-menu__title {
    margin-right: auto !important;
  }
  .van-dropdown-menu__bar {
    border-radius: 10px !important;
  }
}

.contentWrap {
  // background-attachment: fixed;
}
.dateWrap {
  display: flex;
  margin-bottom: 10px;
}
.logWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  height: 60px;
  flex-wrap: wrap;
  transition: 0.3s ease-in-out;
  .orderId {
    height: 0;
    overflow: hidden;
  }
  .left {
    width: 60%;
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .date {
      font-size: 12px;
      color: #999999;
    }
  }
  .right {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .balance {
      color: #009aaa;
      font-size: 14px;
      font-weight: 500;
      margin-right: 5px;
    }
    i {
      color: #999999;
      font-weight: bold;
      font-size: 16px;
      transition: 0.3s ease-in-out;
    }
  }
}
.logWrap.active {
  height: 120px;
  .orderId {
    height: auto;
    width: 100%;
    font-size: 12px;
    padding-right: 20px;
    display: flex;
    position: relative;
    .copyIcon {
      position: absolute;
      right: 0px;
      font-size: 14px;
    }
    .title {
      color: #999999;
      white-space: nowrap;
    }
    .id {
      margin-left: 5px;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .right {
    i {
      transform: rotate(180deg);
    }
  }
}
.rightSelect {
  display: flex;
  align-items: center;
  color: #009aaa;
  .icon {
    // color: #009aaa !important;
  }
}
.leftSelect {
  position: fixed;
  top: 46px;
  bottom: 0px;
  right: 0px;
  left: 0;
  background-color: rgba(black, 0.8);
  z-index: 999;
  overflow: scroll;
  .selectContent {
    width: 80%;
    background-color: #fff;
    position: fixed;
    right: 0;
    top: 46px;
    bottom: 0;
  }
}
.drawerTime {
  border: 0.5px solid #cccccc;
  color: #cccccc;
}
.drawerWrap {
  color: #333333 !important;
  .content {
    .title {
      font-size: 16px;
      font-weight: 500;
      background-color: rgb(242, 242, 242);
      line-height: 50px;
      padding-left: 10px;
    }
  }
  .drawerContentWrap {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    label {
      color: #333333;
      margin-top: 5px;
      line-height: 30px;
    }
    .drawerTime {
      width: 115px;
      // height: 24px;
    }
    .pickerWrap {
      display: flex;
      align-items: center;
      .datePick {
        width: 115px;
        height: 30px;
        align-items: center;
        line-height: 30px;
        border: 0.5px solid #cccccc;
        text-align: center;
        color: #cccccc;
      }
    }
  }
  .footBtnWrap {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    button {
      width: 80px;
      height: 24px;
      margin-left: 5px;
      margin-right: 5px;
    }
    .reset {
      border: 0.5px solid #009aaa;
      color: #009aaa;
    }
    .use {
      background-color: #009aaa;
      color: white;
    }
  }
}
</style>
<style lang="scss">
.tableee {
  .el-table .el-table__cell {
    padding: 0 !important;
  }

  // .el-table__header-wrapper .el-checkbox__input::after {
  //   content: "全选";
  //   position: absolute;
  //   font-size: 12px;
  //   margin-left: 5px;
  //   left: -10px;
  //   z-index: 999;
  //   top: -14px;
  //   color: white;
  // }
  // .el-table--border .el-table__cell:first-child .cell {
  //   padding: 15px 0;
  // }
}

.tableWrap {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  width: 355px;
  padding: 10px 20px;
  padding-bottom: 0px;
  border-radius: 10px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  .tableContent {
    width: 100%;
    display: flex;
    font-size: 14px;
    height: 25px;
    align-items: center;
    .tableTitle {
      font-weight: 400;
      white-space: nowrap;
      width: 60px;
      text-align: left;
      margin-right: 10px;
    }
    .tablesContent {
      color: #999999;
      word-break: break-all;
    }
  }
}
</style>
